import { render, staticRenderFns } from "./ProductSwitch.vue?vue&type=template&id=2e20e324&scoped=true"
import script from "./ProductSwitch.vue?vue&type=script&lang=js"
export * from "./ProductSwitch.vue?vue&type=script&lang=js"
import style0 from "./ProductSwitch.vue?vue&type=style&index=0&id=2e20e324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20e324",
  null
  
)

export default component.exports